
<template>
  <div style="background-color: rgba(236, 243, 255, 1);">
    <section class="section">
      <div style="display: flex;justify-content: center;margin-top: 35px;margin-bottom: 30px">
        <h2 class="section-title">研究布局</h2>
      </div>
      <div class="feature-container">
        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/cart1.png" alt="智能工厂">
          </div>
          <div class="feature-text">
            <h3>大模型研究</h3>
            <p> 大模型研究中心旨在统筹相关创新研究力量开展大模型算法创新和工程系统开发，研究对象包括但不限于语言大模型、视觉大模型、多模态大模型等。同时积极参与滁州市人工智能规划，与中国电信等机构携手，精准对接算力、数据资源，致力于打造国际领先的基础大模型，不断探索多元应用模式，全方位赋能产业升级，为 AI 领域注入源源不断的明晟动力。</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/cart2.png" alt="生产优化">
          </div>
          <div class="feature-text">
            <h3>区块链技术研究</h3>
            <p> 区块链研究中心致力于打造“数据资产+数字资产权益”创新模式中，主要开展数据资产管理与区块链应用方面的应用研究，以及企业数据治理与数字化转型，数据要素市场的建设、数字作品的知识产权保护与服务。通过数据资产确权对企业或者个人的数据资产赋予数字资产，实现对数据资产增值贡献的奖励，分享未来数据资产增值等目标。</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/cart3.png" alt="仓储物流">
          </div>
          <div class="feature-text">
            <h3>具身智能+低空经济</h3>
            <p> 研究多模态大模型赋能的无人机具身智能场景、推进无人机在复杂场景下的感知、传输、处理、记忆、决策、控制、执行和交互等功能的深度融合，实现无人机实现具身感知和决策。 研究方向聚焦低空经济、面向公共服务、工厂巡视等应用场景，实现端到端自主探索、自主学习，为客户提供更柔性、更智能的无人机技术。</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
}
</script>

<style scoped lang="css">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", sans-serif;
}

body {
  background-color: #f5f9ff;
  color: #333;
  line-height: 1.6;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 50px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.logo {
  height: 40px;
}

.nav {
  display: flex;
  gap: 20px;
}

.nav-item {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}


.banner h1 {
  background-image: linear-gradient(45deg, rgba(7, 103, 252, 1) 0, rgba(22, 237, 140, 1) 100%);
  //width: 205px;
  height: 56px;
  overflow-wrap: break-word;
  font-size: 50px;
  font-family: Alimama ShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 56px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px;

}

.banner p {
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  text-align: left;
}

.banner-img {
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.floating-element {
  position: absolute;
  opacity: 0.6;
  z-index: 1;
}

.floating-1 {
  top: 10%;
  left: 10%;
  animation: float 8s ease-in-out infinite;
}

.floating-2 {
  bottom: 15%;
  right: 10%;
  animation: float 10s ease-in-out infinite;
}

.floating-3 {
  top: 60%;
  left: 15%;
  animation: float 12s ease-in-out infinite;
}

@keyframes float {
  0% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
  100% { transform: translateY(0) rotate(0deg); }
}

.section {
  padding: 20px 0;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 32px;
  color: #181F5C;
  margin-bottom: 20px;
  position: relative;
  text-align: center;
  font-family: "Alimama ShuHeiTi-Bold";
}
.section-title:before{
  left: -135px !important;
}
.section-title:after{
  right: -135px !important;
}
.section-title:before {
  content: "";
  background-image: url('assets/img/title-icon-left.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;

  //transform: translateX(-50%);
}
.section-title:after {
  content: "";
  background-image: url('assets/img/title-icon-right.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;
  right: 185px;
  //transform: translateX(-50%);
}

.card-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 30px auto;
  flex-wrap: wrap;
}

.card {
  //background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  width: 386px;
  text-align: left;
  transition: transform 0.3s ease;
}

.card-img {
  //width: 100%;
  ////height: 200px;
  //object-fit: cover;
}

.card-content {
  //width: 386px;
  height: 212px;
  background: linear-gradient( 180deg, #ECF1F9 0%, #FEFEFF 100%);
  border-radius: 0px 0px 0px 0px;
  //border: 1px solid #FFFFFF;
  padding: 20px;
}

.card h3 {
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  font-family: "Alimama ShuHeiTi-Bold";
  //margin-top: 10px;
}

.card p {
  width: 346px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}

.feature-section {
  background-color: #fff;
  padding: 40px 0;
}

.feature-container {
  max-width: 1200px;
  margin: 0 auto;
}

.feature-item {
  display: flex;
  margin-bottom: 10px;
  //align-items: center;
}

.feature-item:nth-child(even) {
  flex-direction: row-reverse;
}

.feature-img {
  flex: 1;
  padding: 20px;
}

.feature-img img {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.feature-text {
  flex: 1;
  padding: 20px;
  text-align: justify;
}

.feature-text h3 {
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  font-family: "Alimama ShuHeiTi-Bold";
}

.feature-text p {
  width: 560px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}

.solution-section {
  //padding: 40px 0;
  //background-color: #f5f9ff;
}

.solution-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.solution-item {
  //width: 48%;
  //background-color: #fff;
  //border-radius: 10px;
  //padding: 20px;
  //margin-bottom: 20px;
  //box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  //text-align: left;
  margin-bottom: 20px;
}
.solution-item div:nth-child(1){
  width: 590px;
  height: 50px;
  background: linear-gradient( 45deg, #0767FC 0%, rgba(7,103,252,0) 100%);
  border-radius: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
}
.solution-item div:nth-child(2){
  width: 590px;
  height: 284px;
  background: linear-gradient( 180deg, #ECF1F9 0%, #FEFEFF 100%);
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #FFFFFF;
  display: flex;
  align-items: center;
  padding: 20px;
}
.solution-item h3 {
  font-weight: 700;
  font-size: 24px;
  color: #FFFFFF;
  font-family: "Alimama ShuHeiTi-Bold";
  margin-left: 20px;
}


.solution-item p {
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  width: 590px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 10px;
}

.footer {
  background-color: #0066cc;
  color: white;
  padding: 40px 0;
}

.footer-container {
  display: flex;
  justify-content: space-around;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.footer-column {
  flex: 1;
  min-width: 200px;
  margin: 10px;
}

.footer-column h3 {
  margin-bottom: 20px;
  font-size: 18px;
}

.footer-column p, .footer-column a {
  color: #e6f0ff;
  text-decoration: none;
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
}

.qrcode {
  width: 100px;
  height: 100px;
  margin-top: 10px;
}
</style>
